import { useForm } from "react-hook-form";
import { SelectedSubscription } from "@/checkout/Sections/SubscriptionSection/types";
import { DEFAULT_CUSTOMER_VALUES } from "@/checkout/Sections/CustomerSection/constants";
import { DEFAULT_TERMS_VALUES } from "@/checkout/Sections/TermsSection/constants";
import { getDefaultFreightValues } from "@/checkout/Sections/FreightSection/selectors";
import { getDefaultSubscriptionValues } from "@/checkout/Sections/SubscriptionSection/selectors";
import { CheckoutForm } from "@/checkout/types";
import { PAYMENT_PROVIDERS } from "@cappelendamm/e-commerce-services";

export const useSubscriptionCheckoutForm = ({
  subscription,
  selectedGiftSkus,
  initialBookSku,
  freight,
  gifts,
  giftSections,
}: SelectedSubscription) => {
  return useForm<CheckoutForm>({
    mode: "onSubmit",
    defaultValues: {
      ...getDefaultSubscriptionValues(
        subscription,
        gifts,
        giftSections,
        initialBookSku,
        selectedGiftSkus,
      ),
      ...getDefaultFreightValues(freight),
      payment: {
        type: PAYMENT_PROVIDERS.NETS,
      },
      ...DEFAULT_CUSTOMER_VALUES,
      ...DEFAULT_TERMS_VALUES,
    },
  });
};
